import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"
import { useState } from "react";
import { useEffect } from "react";

const LoadModal = ({ delay, modelClose, height, children }) => {
    const [open, openchange] = useState(false);
    const closepopup = () => {
        openchange(false);
        modelClose(true);
    }

    useEffect(() => {
        setTimeout(() => {
            openchange(true);
        }, delay);
    }, [delay]);

    return (
        <div style={{ textAlign: 'center' }}>
            <Dialog PaperProps={{ style: { height: height ? height : '65%' } }} open={open} onClose={closepopup} fullWidth maxWidth="md">
                <DialogContent style={{ position: "relative", padding: "0px", overflow: "hidden", background: "#000" }}>
                    <IconButton onClick={closepopup} className="right-0 top-0" style={{ position: 'absolute' }}><CloseIcon className="text-primary z-10"></CloseIcon></IconButton>
                    {children}
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default LoadModal;